import coordData from "./coord-data";


const plans:any = {

'0101_0201_0301_0401_0501_0601_0701_0801' : [101, 201, 301, 401, 501, 601, 701, 801],
'0102' : [102],
'0103_0203' : [103, 203],
'0104_0204' : [104, 204],
'0105_0205' : [105, 205],
'0106_0206_0306_0406_0506_0606' : [106, 206, 306, 406, 506, 606],
'0107_0207' : [107, 207],
'0108_0208_0308' : [108, 208, 308],
'0109_0209_0309' : [109, 209, 309],
'0110_0210_0310' : [110, 210, 310],
'0111_0211_0311' : [111, 211, 311],
'0112_0212_0321_0408_0508_0608_0708' : [112, 212, 321, 408, 508, 608, 708],
'0113_0213_0313_0409_0509_0609_0709_0807' : [113, 213, 313, 409, 509, 609, 709, 807],
'0114_0214_0314_0410_0510_0610_0710_0808_0903_1003_1103' : [114, 214, 314, 410, 510, 610, 710, 808, 903, 1003, 1103],
'0115_0215_0315_0411_0511_0611_0711_0809_0904_1004_1104' : [115, 215, 315, 411, 511, 611, 711, 809, 904, 1004, 1104],
'0116_0216_0316_0412_0512_0612_0712_0810_0905_1005_1105' : [116, 216, 316, 412, 512, 612, 712, 810, 905, 1005, 1105],
'0117_0217_0317_0413_0513' : [117, 217, 317, 413, 513],
'0118_0218' : [118, 218],
'0119' : [119],
'0120_0220' : [120, 220],
'0121_0320_0416' : [121, 320, 416],
'0122_0222' : [122, 222],
'0123_0223' : [123, 223],
'0124_0224' : [124, 224],
'0125_0225' : [125, 225],
'0126_0325_0421' : [126, 325, 421],
'0126_0325_0421_0520' : [126, 325, 421, 520],
'0202_0302_0402_0502_0602_0702_0802' : [202, 302, 402, 502, 602, 702, 802],
'0219' : [219],
'0221' : [221],
'0226' : [226],
'0303_0403_0503_0603_0703_0803' : [303, 403, 503, 603, 703, 803],
'0304_0404_0504_0604_0704_0804' : [304, 404, 504, 604, 704, 804],
'0305_0405_0505_0605_0705_0805' : [305, 405, 505, 605, 705, 805],
'0307' : [307],
'0318_0414' : [318, 414],
'0319' : [319],
'0321_0417_0516' : [321, 417, 516],
'0321_0417_0516_0615_0715_0813' : [321, 417, 516, 615, 715, 813],
'0322_0418_0517' : [322, 418, 517],
'0323_0419_0518' : [323, 419, 518],
'0324_0420' : [324, 420],
'0407' : [407],
'0415' : [415],
'0507_0607_0707' : [507, 607, 707],
'0514' : [514],
'0515' : [515],
'0519_0618_0718' : [519, 618, 718],
'0519_0618_0718_0816' : [519, 618, 718, 816],
'0613_0713_0811' : [613, 713, 811],
'0614' : [614],
'0616_0814' : [616, 814],
'0617_0815' : [617, 815],
'0706' : [706],
'0714' : [714],
'0716' : [716],
'0717' : [717],
'0806' : [806],
'0812' :[812],
'0901_1001_1101' : [901, 1001, 1101],
'0902_1002_1102' : [902, 1002, 1102],
'1': [1],
'2': [2],
'3': [3],
'4': [4],
'5': [5],
'6': [6],
'7': [7],
'8': [8],
'9': [9],
'10': [10],
'11': [11],
'12': [12],
'13': [13],
'14': [14],
'15' : [15],
'16' : [16],
'17' : [17],
'18' : [18],
'19' : [19],
'20' : [20],
'21' : [21],
'22' : [22],
'23' : [23],
'24' : [24],
}


function getPlan(apartmentId: string) {
    // Ground apartments are strings starting with 'G'
    console.log('apartmentId', apartmentId)
    if (apartmentId.startsWith('G')) {
        return apartmentId; // plan key is the same as apartmentId
    }

    var planKeys = Object.keys(plans);
    for (var k = 0; k < planKeys.length; k++) {
        var plan: any = planKeys[k];
        var apartments: number[] = plans[plan];
        var id = parseInt(apartmentId);
        if (apartments.indexOf(id) != -1) {
            return plan;
        }
    }
    return null;
}


function getPDF(planId:string|null){
    if(planId == '4444'
    || planId == '4445'
    || planId == '4446'){
        return `SEK25321_Lumia_FloorplanTemplate_Penthouse_V7_FA_LR_${planId}.pdf`
    }else if(planId && planId.indexOf("P")==0){
        return `SEK25321_Lumia_FloorplanTemplate_Standard_V8_FA_LR_${planId}.pdf`
    }else{
        return planId + ".pdf";
    }
}


export default {
    getPlan,
    getPDF
}